import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";


//RETOUR EN HAUT DE PAGE À CHAQUE CHANGEMENT DE PAGE
//React Router change le contenu sans recharger la page : sans ce composant, on garderait la position de défilement de la page précédente.
//- on ne réagit qu'au changement de page (pathname), pas aux ancres internes (#tarifs…)
//- bouton "Retour" / "Suivant" du navigateur (POP) : on laisse le navigateur retrouver la position précédente
function ScrollToTop() {

  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
